// Automatically import and export all RGS.js files from subdirectories
// This allows adding new providers without modifying this file
const providerContext = require.context("./", true, /^\.\/[^/]+\/RGS\.js$/);

const providers = {};

providerContext.keys().forEach((fileName) => {
  const match = fileName.match(/\.\/(.+)\/RGS\.js$/);
  if (match) {
    const folderName = match[1];
    providers[folderName] = providerContext(fileName).default;
  }
});

export default providers;
